<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>视频会议</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-bottom:20px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20p;text-indent:30px;">
                		高清视频会议系统，满足医疗机构各种场景的视频会议应用，提供应用于会议室、科室、办公室等场所的硬件终端，同时也支持医生通过PC
            </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">、笔记本、手机的软件端加入会议。视频会议融合直播功能，允许用户通过会议直播进行旁听。 完全满足院内及跨医院之间的远程视频会议的应用需求。 </div>
        </div>
        <div class="header-firth" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品框架</span></div>
            <div>
                <img src="@/assets/image/shipin.png" alt="" >
            </div>
        </div>
        <div class="header-forth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-top:10px"><span>应用亮点</span></div>
            <div style="display:flex;justify-content:space-between;margin-top:20px;flex-wrap: wrap">
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;display: flex;align-items: center">
                    <div style="display:flex;">
                        <div  >
                            <img src="@/assets/image/spin.png" alt="" style="padding-top:10px">
                        </div>
                        <div style="padding-left:15px;padding-top:10px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>全平台支持</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持PC、Android、iOS、硬件终端等各个平台，满足各个场景需求 </span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;display: flex;align-items: center">
                            <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu1.png" alt="" style="margin-top:18px">
                        </div>
                        <div style="padding-left:15px;margin-top:18px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>软硬件融合</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持与H323、SIP、监控等第三方硬件融合</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;margin-top:25px;display: flex;align-items: center">
                                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu2.png" alt="">
                        </div>
                      <div style="padding-left:15px;">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;padding-top:5px"><span>灵活部署</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:8px"><span>支持公有云、私有云和混合云部署，满足各类网络要求</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;margin-top:25px;display: flex;align-items: center">
                        <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu3.png" alt="" style="padding-top:10px">
                        </div>
                       <div style="padding-left:15px;padding-top:6px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>开发易集成</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>提供http、app和sdk等多种集成接口方式，便于与业务系统融合</span></div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>